module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/duplicate-a191b905ff07a0a797037d3c8b0f2df3.svg";